import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosClient from "../../axios-client";

// Async thunk for fetchLcaState
export const fetchLcaState = createAsyncThunk(
  "lcAds/fetchLocalCommunityAds",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const response = await axiosClient.put(
        `need/LocalCommunityList`,
        payload
      );
      if (response.data.statusCode === 200) {
        return response.data.Data;
      } else {
        return rejectWithValue(response.data.msg);
      }
    } catch (error) {
      return rejectWithValue("Error fetching LocalCommunity ads");
    }
  }
);

const initialState = {
  activeTab: "Customers",
  searchTerm: "",
  selectedSubCategory: null,
  selectedItem: null,
  radius: [1, 1],
  allProducts: [],
  upcomingProducts: [],
  bwv: [],
  finalBwv: [],
  finalProducts: [],
  dupProducts: [],
  visibleCategories: [],
  showAll: false,
  Lca: [],
  searchQuery: "",
  lcaLoading: false,
  bwvLoading: false,
  bizzLca: [],
  selectedGurdwara: null,
  myOffers: [],
  parentMsg: null,
  selectedAd: null,
  month: "",
  city: "",
  productCities: [],
  guruSubCat: [],
  isMsgModalOpen: false,
  hideSkipped: true,
  skippedAd: null,
  totalCount: 0,
  error: null,
  viewCustType: false,
};

const localCommunityAdsSlice = createSlice({
  name: "lcAds",
  initialState,
  reducers: {
    resetLca(state) {
      state.activeTab = "Customers";
      state.searchTerm = "";
      state.selectedSubCategory = null;
      state.selectedItem = null;
      state.radius = [1, 1];
      state.searchQuery = "";
      state.city = "";
      state.month = "";
      state.hideSkipped = true;
    },
    setShowAll(state, action) {
      state.showAll = action.payload;
    },
    setSearchQuery(state, action) {
      state.searchQuery = action.payload;
    },
    setActiveTab(state, action) {
      state.activeTab = action.payload;
    },
    setSearchTerm(state, action) {
      state.searchTerm = action.payload;
    },
    setSelectedSubCategory(state, action) {
      state.selectedSubCategory = action.payload;
    },
    setSelectedItem(state, action) {
      state.selectedItem = action.payload;
    },
    setRadius(state, action) {
      state.radius = action.payload;
    },
    setAllProducts(state, action) {
      state.allProducts = action.payload;
    },
    setUpcomingProducts(state, action) {
      state.upcomingProducts = action.payload;
    },
    setBwv(state, action) {
      state.bwv = action.payload;
    },
    setFinalBwv(state, action) {
      state.finalBwv = action.payload;
    },
    setFinalProducts(state, action) {
      state.finalProducts = action.payload;
    },
    setLca(state, action) {
      state.Lca = action.payload;
    },
    setDupProducts(state, action) {
      state.dupProducts = action.payload;
    },
    setVisibleCategories(state, action) {
      state.visibleCategories = action.payload;
    },
    setBizzLca(state, action) {
      state.bizzLca = action.payload;
    },
    setSelectedGurdwara(state, action) {
      state.selectedGurdwara = action.payload;
    },
    setMyOffers(state, action) {
      state.myOffers = action.payload;
    },
    setParentMsg(state, action) {
      state.parentMsg = action.payload;
    },
    setSelectedAd(state, action) {
      state.selectedAd = action.payload;
    },
    setMonth(state, action) {
      state.month = action.payload;
    },
    setCity(state, action) {
      state.city = action.payload;
    },
    setProductCities(state, action) {
      state.productCities = action.payload;
    },
    setGuruSubCat(state, action) {
      state.guruSubCat = action.payload;
    },
    setIsMsgModalOpen(state, action) {
      state.isMsgModalOpen = action.payload;
    },
    setHideSkipped(state, action) {
      state.hideSkipped = action.payload;
    },
    setSkippedAd(state, action) {
      state.skippedAd = action.payload;
      const ad = action.payload;
      const updateArray = (array) =>
        array.map((item) => (item.Id === ad.Id ? ad : item));

      if (ad?.needSkipCustomer === 1 && state.hideSkipped) {
        state.Lca = state.Lca.filter((item) => item.Id !== ad.Id);
        state.allProducts = state.allProducts.filter(
          (item) => item.Id !== ad.Id
        );
      } else {
        const existingLcaIds = state.Lca.map((item) => item.Id);
        if (existingLcaIds.includes(ad.Id)) {
          state.Lca = updateArray(state.Lca);
        } else {
          state.Lca = [...state.Lca, ad];
        }

        const existingProductIds = state.allProducts.map((item) => item.Id);
        if (existingProductIds.includes(ad.Id)) {
          state.allProducts = updateArray(state.allProducts);
        } else if (ad.engagedCouple !== 1) {
          state.allProducts = [...state.allProducts, ad];
        }
      }
      console.log("Updated Lca:", state.Lca);
    },
    setTotalCount(state, action) {
      state.totalCount = action.payload;
    },
    setLcaLoading(state, action) {
      state.lcaLoading = action.payload;
    },
    setBwvLoading(state, action) {
      state.bwvLoading = action.payload;
    },
    setViewCustType(state, action) {
      state.viewCustType = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLcaState.pending, (state) => {
        state.lcaLoading = true;
        state.error = null;
      })
      .addCase(fetchLcaState.fulfilled, (state, action) => {
        state.lcaLoading = false;
        const ads = action.payload;
        const uniqueAds = [
          ...new Map(ads.map((item) => [item.Id, item])).values(),
        ];
        const existingAllProducts = state.allProducts;
        const existingLca = state.Lca;
        const existingIdsAllProducts = existingAllProducts.map(
          (product) => product.Id
        );
        const existingIdsLca = existingLca.map((product) => product.Id);
        const newProducts = uniqueAds.filter(
          (ad) => !existingIdsAllProducts.includes(ad.Id)
        );
        const filterNormalNeeds = newProducts.filter(
          (product) => product.engagedCouple !== 1
        );
        const newLca = uniqueAds.filter(
          (ad) => !existingIdsLca.includes(ad.Id)
        );

        // Combine and deduplicate filteredProducts
        const filteredProducts = [
          ...new Map(
            [...filterNormalNeeds, ...newLca].map((item) => [item.Id, item])
          ).values(),
        ];
        console.log("filteredProducts:", filteredProducts);

        state.allProducts = [
          ...existingAllProducts,
          ...filteredProducts.filter(
            (ad) =>
              ad.engagedCouple !== 1 && !existingIdsAllProducts.includes(ad.Id)
          ),
        ];
        state.Lca = [
          ...existingLca,
          ...filteredProducts.filter((ad) => !existingIdsLca.includes(ad.Id)),
        ];

        state.bizzLca = [
          ...new Map(
            [...state.bizzLca, ...uniqueAds].map((item) => [item.Id, item])
          ).values(),
        ];

        console.log("Updated allProducts:", state.allProducts);
        console.log("Updated Lca:", state.Lca);
        console.log("Updated bizzLca:", state.bizzLca);
      })
      .addCase(fetchLcaState.rejected, (state, action) => {
        state.lcaLoading = false;
        state.error = action.payload || "Error fetching LocalCommunity ads";
      });
  },
});

export const {
  resetLca,
  setActiveTab,
  setSearchTerm,
  setSelectedSubCategory,
  setSelectedItem,
  setRadius,
  setAllProducts,
  setUpcomingProducts,
  setBwv,
  setFinalBwv,
  setFinalProducts,
  setLca,
  setDupProducts,
  setVisibleCategories,
  setShowAll,
  setSearchQuery,
  setLcaLoading,
  setBwvLoading,
  setBizzLca,
  setSelectedGurdwara,
  setMyOffers,
  setParentMsg,
  setSelectedAd,
  setMonth,
  setCity,
  setProductCities,
  setGuruSubCat,
  setIsMsgModalOpen,
  setHideSkipped,
  setSkippedAd,
  setTotalCount,
  setViewCustType,
} = localCommunityAdsSlice.actions;

export default localCommunityAdsSlice.reducer;
